import { Pipe, PipeTransform } from '@angular/core';
import { StatusWorkflowFieldType } from 'src/app/api/models';

@Pipe({
  name: 'fieldType',
})
export class FieldTypePipe implements PipeTransform {
  transform(value: StatusWorkflowFieldType): string {
    return fieldType(value);
  }
}

export const fieldType = (value: StatusWorkflowFieldType): string => {
  switch (value) {
    case StatusWorkflowFieldType.String:
      return 'Stringa';
    case StatusWorkflowFieldType.Date:
      return 'Data';
    case StatusWorkflowFieldType.Number:
      return 'Numero intero';
    case StatusWorkflowFieldType.Float:
      return 'Numero decimale';
    case StatusWorkflowFieldType.Currency:
      return 'Valuta';
    default:
      return 'Sconosciuto';
  }
};
